module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/send-email/send-email.component.css
// module id = ./src/app/send-email/send-email.component.css
// module chunks = main